module.exports = __webpack_public_path__ + "static/media/pencil02.9e3bcefa.webp";